import React from "react";
import {
  Button,
  ButtonGroup,
  Container,
  Col,
  Table,
  Row,
  FormGroup,
  Label,
  Input,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Form,
  FormText,
} from "reactstrap";
import axios from "axios";
import numeral from "numeral";
import moment from "moment";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";

const Clientdetails = (props) => {
  // console.log(props.location);
  if (!props.location.state || !props.location.state.client)
    return props.history.push("/dashboard");
  const [state, setState] = React.useState({
    client: props.location.state ? props.location.state.client : {},
  });
  const [cards, setCards] = React.useState([]);
  const [upload, setUpload] = React.useState({});

  const [payments, setPayments] = React.useState([]);
  const [references, setReferences] = React.useState([]);

  const [reference, setReference] = React.useState({
    loanAmount: 0,
    repayment: 0,
    totalRepayment: 0,
    numberOfRepayments: 0,
  });

  const [loading, setLoading] = React.useState(false);
  const [modal, setModal] = React.useState(false);
  const [pmodal, setPModal] = React.useState(false);
  const [rmodal, setRModal] = React.useState(false);
  const [smodal, setSModal] = React.useState(false);

  const toggle = () => setModal(!modal);
  const toggleReference = () => setRModal(!rmodal);
  const toggleSetup = () => setSModal(!smodal);
  const togglePayment = () => setPModal(!pmodal);

  const getCards = async () => {
    try {
      setLoading(true);
      // prompt to get amount
      const { data: cards } = await axios.get(
        `/api/getcards/${state.client._id}`,
        {
          headers: { Authorization: localStorage.getItem("token") },
        }
      );
      setCards(cards);
    } catch (error) {
      console.log(error);
      toast("Could not process request");
    } finally {
      setLoading(false);
    }
  };

  const getPayments = async () => {
    try {
      const { data } = await axios.get(`/api/getpayments/${state.client._id}`, {
        headers: { Authorization: localStorage.getItem("token") },
      });
      setPayments(data);
    } catch (error) {
      console.log(error);
      toast("Could not process request");
    }
  };

  const getReferences = async () => {
    try {
      const { data } = await axios.get(
        `/api/finddatareference/${state.client._id}`,
        {
          headers: { Authorization: localStorage.getItem("token") },
        }
      );

      setReferences(data);
    } catch (error) {
      console.log(error);
      toast("Could not process request");
    }
  };

  const getUpload = async () => {
    try {
      const { data } = await axios.get(`/api/getUpload/${state.client._id}`, {
        headers: { Authorization: localStorage.getItem("token") },
      });

      setUpload(data);
    } catch (error) {
      console.log(error);
      toast("Could not process request");
    }
  };

  React.useEffect(() => {
    getCards();
    getPayments();
    getReferences();
    getUpload();
  }, []);

  const verifyCard = async (card_id) => {
    try {
      setLoading(true);
      // prompt to get amount
      const { data: cards } = await axios.get(`/api/verifycard/${card_id}`, {
        headers: { Authorization: localStorage.getItem("token") },
      });
      getCards();
    } catch (error) {
      console.log(error);
      if (
        error.response &&
        error.response.data &&
        typeof error.response.data === "string"
      )
        toast.error(error.response.data);

      toast("could not verify card");
    } finally {
      setLoading(false);
    }
  };

  const verifyPayment = async (paymentid) => {
    try {
      setLoading(true);
      // prompt to get amount
      const { data: payment } = await axios.get(
        `/api/verifypayment/${paymentid}`,
        {
          headers: { Authorization: localStorage.getItem("token") },
        }
      );
      getPayments();
    } catch (error) {
      if (
        error.response &&
        error.response.data &&
        typeof error.response.data === "string"
      )
        toast.error(error.response.data);

      console.log(error);
      toast("could not verify payment");
    } finally {
      setLoading(false);
    }
  };

  const chargeCard = async (card_id) => {
    try {
      setLoading(true);
      // prompt to get amount
      const amount = window.prompt("how much do you want to charge");
      if (amount && window.confirm("Are you sure?")) {
        const { data } = await axios.post(
          `/api/chargecard/${card_id}`,
          { amount },
          { headers: { Authorization: localStorage.getItem("token") } }
        );
        alert("charge sent successfully");
        getPayments();
      }
      // getCards();
    } catch (error) {
      if (
        error.response &&
        error.response.data &&
        typeof error.response.data === "string"
      )
        toast.error(error.response.data);

      console.log(error, error.response);
      toast("could not charge card");
    } finally {
      setLoading(false);
    }
  };

  const setupMandate = async () => {
    try {
      setLoading(true);
      // prompt to get amount
      const amount = window.prompt("Input Amount for Mandate");

      if (amount && !isNaN(amount)) {
        const payLoad = {
          email: state.client.email,
          phoneNumber: state.client.phoneNumber,
          bank: state.client.bank,
          accountNumber: state.client.accountNumber,
          amount,
          name: `${state.client.firstname} ${state.client.middlename} ${state.client.lastname}`,
          client: state.client._id,
          clientId: state.client.clientId,
        };
        const { data: mandateData } = await axios.post(
          "/api/setupMandate",
          payLoad,
          { headers: { Authorization: localStorage.getItem("token") } }
        );
        //  console.log(mandateData);
        alert("mandate created successfully");
      }
    } catch (error) {
      console.log(error);
      if (
        error.response &&
        error.response.data &&
        typeof error.response.data === "string"
      )
        toast.error(error.response.data);

      toast("An error occured");
    } finally {
      setLoading(false);
    }
  };

  const setupCard = async () => {
    try {
      setLoading(true);
      const payLoad = {
        email: state.client.email,
        client: state.client._id,
      };
      if (window.confirm("are you sure")) {
        const { data: cardData } = await axios.post(
          "/api/checkoutinit",
          payLoad,
          { headers: { Authorization: localStorage.getItem("token") } }
        );
        getCards();
        // console.log(cardData);
        alert("link has been generated");
      }
    } catch (error) {
      console.log(error, error.response);
      if (
        error.response &&
        error.response.data &&
        typeof error.response.data === "string"
      )
        toast.error(error.response.data);
      toast("an error occured");
    } finally {
      setLoading(false);
    }
  };

  const checkDeduction = async () => {
    try {
      setLoading(true);
      const payLoad = {
        phoneNumber: state.client.phoneNumber,
        client: state.client._id,
      };
      if (window.confirm("Are You Sure")) {
        const { data } = await axios.post("/api/datareference", payLoad, {
          headers: { Authorization: localStorage.getItem("token") },
        });
        toast.info("List Refreshed");
        getReferences();
      }
    } catch (error) {
      if (
        error.response &&
        error.response.data &&
        typeof error.response.data === "string"
      )
        toast.error(error.response.data);
      console.log(error);
      toast("An error occured");
    } finally {
      setLoading(false);
    }
  };

  const setupDeduction = async () => {
    try {
      setLoading(true);
      const payLoad = {
        loanAmount: reference.loanAmount,
        repayment: reference.repayment,
        totalRepayment: reference.totalRepayment,
        numberOfRepayments: reference.numberOfRepayments,
        client: state.client._id,
      };
      if (window.confirm("Are You Sure")) {
        const { data } = await axios.post("/api/setupdeduction", payLoad, {
          headers: { Authorization: localStorage.getItem("token") },
        });
        toast.success("Referencing mandate generated successfully");
        toggleSetup();

        // getReferences();
      }
    } catch (error) {
      if (
        error.response &&
        error.response.data &&
        typeof error.response.data === "string"
      )
        toast.error(error.response.data);
      console.log(error);
      toast("An error occured");
    } finally {
      setLoading(false);
    }
  };

  const runLoanReport = (report) => {
    let lines = "";
    if (report && Array.isArray(report)) {
      report.map((rep) => {
        lines += `Loan Provider - ${rep.loanProvider}\nAmount - ${rep.loanAmount}\nOutstanding Amount - ${rep.outstandingAmount}\nLoan Disbursement Date - ${rep.loanDisbursementDate}\nRepayment Amount - ${rep.repaymentAmount}\nRepayment Frequency - ${rep.repaymentFreq}\nStatus - ${rep.status}\n\n`;
      });
    }
    // console.log(lines);
    return lines;
  };
  const runSalaryReport = (report) => {
    let lines = "";
    if (report && Array.isArray(report)) {
      report.map((rep) => {
        lines += `Payment Date - ${rep.paymentDate}\nAmount - ${rep.amount}\nAccount Number - ${rep.accountNumber}\nBank Code - ${rep.bankCode}\n\n`;
      });
    }
    // console.log(lines);
    return lines;
  };

  return (
    <Container>
      <Modal size="lg" isOpen={modal} toggle={toggle}>
        <ModalHeader toggle={toggle}>Cards</ModalHeader>
        <ModalBody>
          <Table striped hover responsive>
            <thead>
              <tr>
                <th>#</th>
                <th>Status</th>
                <th>Reference</th>
                <th>cc</th>
                <th>expiry</th>
                <th>bank</th>
                <th>card type</th>
                <th>Reusable</th>
                <th>paymentLink</th>
                <th />
                <th />
              </tr>
            </thead>
            <tbody>
              {cards.map((item, i) => (
                <tr key={item._id}>
                  <td>{i + 1}</td>
                  <td>{item.status}</td>
                  <td>{item.reference}</td>
                  <td>
                    {item.bin}
                    ******
                    {item.last4}
                  </td>
                  <td>
                    {item.expMonth}/{item.expYear}
                  </td>
                  <td>{item.bank}</td>
                  <td>{item.cardType}</td>
                  <td>{item.reusable ? "can charge" : "cannot charge"}</td>
                  <td>{item.url}</td>
                  <td>
                    {" "}
                    <Button
                      onClick={() => chargeCard(item._id)}
                      disabled={!item.reusable || !item.token}
                      color="primary"
                    >
                      charge
                    </Button>
                  </td>
                  <td>
                    {" "}
                    <Button
                      onClick={() => verifyCard(item._id)}
                      disabled={item.token}
                      color="info"
                    >
                      verify
                    </Button>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </ModalBody>
        <ModalFooter>
          {" "}
          <Button color="secondary" onClick={toggle}>
            Cancel
          </Button>
        </ModalFooter>
      </Modal>

      <Modal size="lg" isOpen={pmodal} toggle={togglePayment}>
        <ModalHeader toggle={togglePayment}>Payments</ModalHeader>
        <ModalBody>
          <Table striped hover responsive>
            <thead>
              <tr>
                <th>#</th>
                <th>Status</th>
                <th>Reference</th>
                <th>Amount</th>
                <th />
              </tr>
            </thead>
            <tbody>
              {payments.map((item, i) => (
                <tr key={item._id}>
                  <td>{i + 1}</td>
                  <td>{item.status}</td>
                  <td>{item.reference}</td>
                  <td>{item.amount}</td>
                  <td>
                    {" "}
                    <Button
                      onClick={() => verifyPayment(item._id)}
                      color="info"
                    >
                      verify
                    </Button>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </ModalBody>
        <ModalFooter>
          {" "}
          <Button color="secondary" onClick={togglePayment}>
            Cancel
          </Button>
        </ModalFooter>
      </Modal>

      <Modal size="lg" isOpen={rmodal} toggle={toggleReference}>
        <ModalHeader toggle={toggleReference}>Deductions</ModalHeader>
        <ModalBody>
          <Table striped hover responsive>
            <thead>
              <tr>
                <th>Salary History</th>
                <th>Deductions</th>
                <th />
              </tr>
            </thead>
            <tbody>
              {references.map((item, i) => (
                <tr key={item._id}>
                  <td>
                    {" "}
                    <pre>{runSalaryReport(item.salaryPaymentDetails)}</pre>
                  </td>
                  <td>
                    {" "}
                    <pre>{runLoanReport(item.loanHistoryDetails)}</pre>
                  </td>
                  <td>
                    {item.log && typeof item.log === "string" ? item.log : ""}
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </ModalBody>
        <ModalFooter>
          {" "}
          <Button color="danger" onClick={checkDeduction}>
            Check Deductions
          </Button>
        </ModalFooter>
      </Modal>

      <Modal size="lg" isOpen={smodal} toggle={toggleSetup}>
        <ModalHeader toggle={toggleSetup}>Setup Deduction</ModalHeader>
        <ModalBody>
          <Form>
            <FormGroup row>
              <Label for="exampleEmail" sm={2}>
                Loan Amount
              </Label>
              <Col sm={10}>
                <Input
                  type="number"
                  name="lamt"
                  id="lamt"
                  placeholder="1xxxxx"
                  value={reference.loanAmount}
                  onChange={(e) =>
                    setReference({ ...reference, loanAmount: e.target.value })
                  }
                />
              </Col>
            </FormGroup>
            <FormGroup row>
              <Label for="exampleEmail" sm={2}>
                Repayment Amount
              </Label>
              <Col sm={10}>
                <Input
                  type="number"
                  name="ramt"
                  id="ramt"
                  placeholder="1xxxxx"
                  value={reference.repayment}
                  onChange={(e) =>
                    setReference({ ...reference, repayment: e.target.value })
                  }
                />
              </Col>
            </FormGroup>
            <FormGroup row>
              <Label for="exampleEmail" sm={2}>
                Total Repayment
              </Label>
              <Col sm={10}>
                <Input
                  type="number"
                  name="tamt"
                  id="tamt"
                  placeholder="1xxxxx"
                  value={reference.totalRepayment}
                  onChange={(e) =>
                    setReference({
                      ...reference,
                      totalRepayment: e.target.value,
                    })
                  }
                />
              </Col>
            </FormGroup>
            <FormGroup row>
              <Label for="exampleEmail" sm={2}>
                Number of Repayments
              </Label>
              <Col sm={10}>
                <Input
                  type="number"
                  name="nr"
                  id="nr"
                  placeholder="1xxxxx"
                  value={reference.numberOfRepayments}
                  onChange={(e) =>
                    setReference({
                      ...reference,
                      numberOfRepayments: e.target.value,
                    })
                  }
                />
              </Col>
            </FormGroup>
            <Row className="justify-content-center my-2">
              <Button
                type="button"
                color="danger"
                className="btnprimary"
                onClick={setupDeduction}
              >
                Setup
              </Button>
            </Row>
          </Form>
        </ModalBody>
        <ModalFooter>
          {" "}
          <Button color="danger" onClick={toggleSetup}>
            Close
          </Button>
        </ModalFooter>
      </Modal>

      <Row>
        <Col md={12}>
          <Table striped hover responsive>
            <tbody>
              <tr>
                <th>Setup Direct Debit</th>
                <td>
                  <Button
                    disabled={loading}
                    onClick={setupMandate}
                    size="sm"
                    color="primary"
                  >
                    Setup Remita DD
                  </Button>{" "}
                  <Button
                    onClick={() =>
                      props.history.push(`/mandates/${state.client.clientId}`)
                    }
                    disabled={loading}
                    size="sm"
                    color="success"
                  >
                    View DD Mandate
                  </Button>{" "}
                  <Button
                    disabled={loading}
                    onClick={setupCard}
                    size="sm"
                    color="info"
                  >
                    Setup Paystack DD
                  </Button>
                </td>
              </tr>
              <tr>
                <th>Cards</th>
                <td>
                  <Button
                    onClick={toggle}
                    disabled={loading}
                    size="sm"
                    color="warning"
                  >
                    View Cards
                  </Button>{" "}
                  <Button
                    onClick={togglePayment}
                    disabled={loading}
                    size="sm"
                    color="secondary"
                  >
                    View Payments
                  </Button>
                </td>
              </tr>

              <tr>
                <th>Data referencing</th>
                <td>
                  <Button
                    onClick={toggleSetup}
                    disabled={loading}
                    size="sm"
                    color="danger"
                  >
                    Setup referencing deduction
                  </Button>{" "}
                  <Button
                    onClick={toggleReference}
                    disabled={loading}
                    size="sm"
                    color="warning"
                  >
                    Check referencing deductions
                  </Button>{" "}
                  <Button
                    onClick={() =>
                      props.history.push(
                        `/referencemandates/${state.client._id}`
                      )
                    }
                    disabled={loading}
                    size="sm"
                    color="info"
                  >
                    View referencing mandates
                  </Button>
                </td>
              </tr>
              <tr>
                <th>Client ID</th>
                <td>
                  {state.client.clientId}{" "}
                  <Button
                    onClick={(e) => e.stopPropagation()}
                    disabled={loading}
                    tag="a"
                    size="sm"
                    href={`/loans/${state.client.clientId}/${state.client.firstname} ${state.client.lastname}`}
                    className="btnprimary"
                    color="info"
                  >
                    View Loans
                  </Button>
                </td>
              </tr>
              <tr>
                <th>Title</th>
                <td>{state.client.title}</td>
              </tr>
              <tr>
                <th>Client Name</th>
                <td>
                  {state.client.firstname} {state.client.middlename}{" "}
                  {state.client.lastname}
                </td>
              </tr>
              <tr>
                <th>Gender</th>
                <td>{state.client.gender}</td>
              </tr>
              <tr>
                <th>Date of Birth</th>
                <td>{moment(state.client.dob).format("DD MMMM YYYY")}</td>
              </tr>
              <tr>
                <th>Email</th>
                <td>{state.client.email}</td>
              </tr>

              <tr>
                <th>Phone Number</th>
                <td>{state.client.phoneNumber}</td>
              </tr>
              <tr>
                <th>Alternate Phone Number</th>
                <td>{state.client.alternatePhoneNumber}</td>
              </tr>
              <tr>
                <th>Address</th>
                <td>{state.client.address}</td>
              </tr>
              <tr>
                <th>City</th>
                <td>{state.client.city}</td>
              </tr>
              <tr>
                <th>State</th>
                <td>{state.client.state}</td>
              </tr>
              <tr>
                <th>Employer</th>
                <td>{state.client.employer}</td>
              </tr>
              <tr>
                <th>Employee Number</th>
                <td>{state.client.employeeNumber}</td>
              </tr>
              <tr>
                <th>Date of Employment</th>
                <td>
                  {moment(state.client.dateOfEmployment).format("DD MMMM YYYY")}
                </td>
              </tr>

              <tr>
                <th>Bank</th>
                <td>{state.client.bank}</td>
              </tr>
              <tr>
                <th>Account Number</th>
                <td>{state.client.accountNumber}</td>
              </tr>
              <tr>
                <th>BVN</th>
                <td>{state.client.bvn}</td>
              </tr>
              <tr>
                <th>ID Card</th>
                <td>
                  <Button
                    onClick={() => {
                      const a = document.createElement("a"); // Create <a>
                      a.href = upload.idCard;
                      a.download = "ID Card";
                      a.click();
                    }}
                    size="sm"
                    color="primary"
                  >
                    Download
                  </Button>
                </td>
              </tr>
              <tr>
                <th>Payslip 1</th>
                <td>
                  <Button
                    onClick={() => {
                      const a = document.createElement("a"); // Create <a>
                      a.href = upload.paySlip1;
                      a.download = "Pay Slip 1";
                      a.click();
                    }}
                    size="sm"
                    color="primary"
                  >
                    Download
                  </Button>
                </td>
              </tr>
              <tr>
                <th>Payslip 2</th>
                <td>
                  <Button
                    onClick={() => {
                      const a = document.createElement("a"); // Create <a>
                      a.href = upload.paySlip2;
                      a.download = "Pay Slip 2";
                      a.click();
                    }}
                    size="sm"
                    color="primary"
                  >
                    Download
                  </Button>
                </td>
              </tr>
            </tbody>
          </Table>
        </Col>
      </Row>
    </Container>
  );
};

export default Clientdetails;
